export default __webpack_public_path__ + "static/media/image2.86113ac6.png";